export function StatCard({ label, value, unit, hint, tone = "default", testid, icon }) {
  const tones = {
    default: "border-[#E5E5DF] bg-white",
    primary: "border-[#1B4332]/20 bg-[#F0F5F1]",
    accent: "border-[#D8F3DC] bg-[#D8F3DC]/40",
    warning: "border-[#E07A5F]/30 bg-[#FDF3EF]",
  };
  return (
    <div
      data-testid={testid}
      className={`relative flex flex-col justify-between rounded-lg border p-5 md:p-6 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[0_8px_32px_rgba(0,0,0,0.04)] ${tones[tone]}`}
    >
      <div className="flex items-start justify-between mb-4">
        <span className="overline text-[#52796F]">{label}</span>
        {icon}
      </div>
      <div className="flex items-baseline gap-2">
        <span className="mono-num text-3xl md:text-4xl font-semibold text-[#1A1A1A]">{value}</span>
        {unit && <span className="text-xs text-[#4A4A4A] mb-1">{unit}</span>}
      </div>
      {hint && <p className="text-xs text-[#4A4A4A] mt-2">{hint}</p>}
    </div>
  );
}
